<template>
  <v-textarea
    :value="value"
    @input="$emit('input', $event)"
    :hide-details="hideDetails"
    auto-grow
    outlined
    class="text-area"
    :placeholder="placeholder"
    :label="label"
    :type="type"
    :rows="rows"
    :rules="rules"
    :counter="counter"
    :disabled="disabled"
  ></v-textarea>
</template>

<script>
export default {
  props: {
    placeholder: String,
    label: String,
    value: String,
    rows: Number,
    type: {
      type: String,
      default: "text",
    },
    rules: {
      type: Array,
      default: () => [],
    },
    hideDetails: {
      default: "auto",
    },
    counter: {
      default: null,
    },
    light: Boolean,
    disabled: Boolean,
  },
};
</script>

<style scoped lang="scss">
.text-area {
  width: 100%;

  &::v-deep {
    &:not(.v-input--has-state) {
      fieldset {
        border-color: var(--v-border-base);
      }

      .v-input__slot:hover fieldset {
        border-color: rgba(0, 0, 0, 0.3);
      }
    }

    &.v-input--has-state fieldset {
      border-color: var(--v-primary-base) !important;
    }
  }
}

.disabled-theme .text-area {
  &::v-deep {
    fieldset {
      border-color: rgba(0, 0, 0, 0.38);
    }
  }
}
</style>
